import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import globalModules from './modules/globalModules'
import globalComponents from './modules/globalComponents'
import { setAppFavicon, setAppTitle } from '@/helpers/env'

Vue.config.productionTip = false
Vue.config.silent = true

new Vue({
    router,
    store,
    i18n,
    async beforeCreate() {
        globalModules(this)
        globalComponents()
        setAppFavicon()
        setAppTitle()
        await this.$Language.setupInitLanguage(this)
    },
    render: h => h(App)
}).$mount('#app')
